import React from "react";
import ReactDOM from "react-dom/client";
import { ThemeProvider, type ThemeConfig } from "@repo/core";
import { App } from "./App";
import "./styles/globals.css";

const isDemo =
  import.meta.env.VITE_DEMO_MODE === "true" ||
  new URLSearchParams(window.location.search).has("demo");

/** Curated Clean preset — default for first open (and demo). */
const CLEAN_THEME: Partial<ThemeConfig> = {
  colorMode: "system",
  preset: "mint",
  radius: "lg",
  template: "clean",
};

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <ThemeProvider
      defaultTheme={CLEAN_THEME}
      storageKey={isDemo ? "budgetos-demo-theme" : "etsy-fw-theme"}
    >
      <App />
    </ThemeProvider>
  </React.StrictMode>
);
